<template>
  <div class="drag-outer" :style="outerOptions" @mouseenter="isHover = true" @mouseleave="isHover = isMousedown = false"
    @mousemove="dragMousemove">
    <div class="drag-inner" ref="dragElement" :style="innerOptions" @mousedown.stop="dragMousedown"
      @mouseup.stop="isMousedown = false">
      <slot></slot>
    </div>
  </div>
</template>

<script  type="text/ecmascript-6">
export default {
  name: 'ElementDrag',
  props: {
    outerOptions: {
      type: Object,
      default() {
        return {
          background: 'rgba(0,0,0,0.9)'
        };
      }
    },
    innerOptions: {
      type: Object,
      default() {
        return {
          background: 'rgba(0,0,0,0.1)'
        };
      }
    },
    scaleZoom: {
      type: Object,
      default() {
        return {
          max: 5,
          min: 0.2
        };
      }
    }
  },
  data() {
    return {
      rotate: 0,
      isMousedown: false,
      isHover: false,
      moveStart: {},
      translate: { x: 0, y: 0 },
      scale: 1
    };
  },
  methods: {
    // 按钮放大
    magnify() {
      if (this.scale >= 2) {
        return;
      }
      this.scale += 0.25;
      this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
    },
    // 按钮缩小
    shrink() {
      if (this.scale <= 0.5) {
        return;
      }
      this.scale -= 0.25;
      this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
    },
    leftRotate(index) {
      this.rotate = Number(this.rotate) - 90;
      // 获取插槽下的第index个child元素（img图片），用来旋转；
      this.$refs.dragElement.childNodes[index].style.transform = `rotate(${this.rotate}deg)`;
    },
    rightRotate(index) {
      this.rotate = Number(this.rotate) + 90;
      // 获取插槽下的第index个child元素（img图片），用来旋转；
      // this.$refs.dragElement.firstElementChild.style.transform = `rotate(${this.rotate}deg)`;
      this.$refs.dragElement.childNodes[index].style.transform = `rotate(${this.rotate}deg)`;
    },
    // 重置图片的旋转角度，为0
    rotateReset(index) {
      this.rotate = 0;
      this.$refs.dragElement.childNodes[index].style.transform = `rotate(${this.rotate}deg)`;
    },
    handleScroll(e) {
      if (this.isHover) {
        let speed = e.wheelDelta / 120;
        if (e.wheelDelta > 0 && this.scale < this.scaleZoom.max) {
          this.scale += 0.04 * speed;
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
        } else if (e.wheelDelta < 0 && this.scale > this.scaleZoom.min) {
          this.scale += 0.04 * speed;
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
        }
      }
    },
    dragMousedown() {
      this.moveStart.x = event.clientX;
      this.moveStart.y = event.clientY;
      this.isMousedown = true;
    },
    dragMousemove() {
      if (this.isMousedown) {
        this.translate.x += (event.clientX - this.moveStart.x) / this.scale;
        this.translate.y += (event.clientY - this.moveStart.y) / this.scale;
        this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`;
        this.moveStart.x = event.clientX;
        this.moveStart.y = event.clientY;
      }
    }
  },
  mounted() {
    window.addEventListener('mousewheel', this.handleScroll, false);
  }
};
</script>

<style lang="scss" scoped>
.drag-outer {
  width: 100%;
  height: 100%;
  min-height: 620px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  .drag-inner {
    transform-origin: center center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: move;
    user-select: none;

    >* {
      -webkit-user-drag: none;
      user-drag: none;
    }
  }
}
</style>
